
































































































import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import { ProjectBudgetViewModel, ProjectViewModel } from "@/services/api/nswag/stapiclient_generated";
import { UserStore } from "@/store/user-module";
import StProgress from "@/components/basic/StProgress.vue";
import ProjectBudget from "@/views/Projects/ProjectBudget.vue";
import { formatDate } from "@/utlitities/helper";
import StBadge from '@/components/basic/StBadge.vue';

@Component({
  methods: { formatDate },
  components: {
    StBadge,
    StProgress,
    ProjectBudget
  }
})
export default class ProjectSingle extends Vue {

  @Prop() project!: ProjectViewModel;
  @Prop() budgetLoading!: boolean;
  @Prop() canViewBudget!: boolean;
  @Prop() hasBudget!: boolean;
  @Prop() budget!: ProjectBudgetViewModel;
  @Prop() showProjectTasks!: boolean;
  @Prop() archiveLoading!: boolean;
  @Prop() finishLoading!: boolean;
  @Prop() delLoading!: boolean;
  @Prop() isDummyCustomerProject!: boolean;

  get canViewRates() {
    return UserStore.userSettings.CanViewRates && !UserStore.userSettings.noRates;
  }

  get canViewProjectReport() {
    return UserStore.userSettings.CanViewTimeEntriesForEmployees;
  }

  get canEditCustomersAndProjects() {
    return UserStore.userSettings.CanEditCustomersAndProjects;
  }

  get useCustomerProjectId() {
    return UserStore.userSettings.featureFlagCustomerProjectId;
  }

  editProject(item: ProjectViewModel) {
    if (this.canEditCustomersAndProjects) {
      let params: any = { customerid: item.customerId!.toString(), projectid: item.id!.toString() };
      let name = 'EditProject';

      if(item.isReadonly){
        params.readonly = true;
        name = 'ViewProject';
      }

      this.$router.push({
        name: name,
        params: params
      });
    }
  }

  projectReport(item: ProjectViewModel) {
    this.$router.push({
      name: "ProjectReport",
      params: { customerid: item.customerId!.toString(), projectid: item.id!.toString() }
    });
  }

  get currency() {
    return UserStore.userSettings.currency;
  }

  @Emit("toggleFinish")
  toggleFinish(id: number) {
    return id;
  }

  @Emit("toggleArchive")
  toggleArchive(id: number) {
    return id;
  }

  @Emit("projectDelete")
  projectDelete(id: number) {
    return id;
  }

}
